import ModalContainer from './Modal';
export default ModalContainer;
